export default __webpack_public_path__ + "static/media/e-commerce.d5112726.png";